export default __webpack_public_path__ + "static/media/File No. 21.27ac4ead.pdf";